import React from "react";
import '../../components/KeyFeature/KeyFeature.css';
import key from '../../assets/images/keybg copy.webp';
import '../../styles/CustomClassCss/Custom.css';
import { IoMdSearch } from "react-icons/io";
import { MdChecklistRtl } from "react-icons/md";
import { IoDocumentTextOutline } from "react-icons/io5";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const KeyFeature = () => {
  const features = [
    {
      icon: <IoMdSearch />,
      title: "Advanced Search and Filtering",
      description:
        " Stelmart’s intuitive search filters allow users to easily find the right steel and polymer products based on critical criteria like size, material, grade, and finish.",
    },
    {
      icon: <MdChecklistRtl />,
      title: "Turnkey Solutions",
      description:
        " We offer end-to-end support, from product selection to final delivery. We handle all the details, ensuring a seamless process for both buyers and sellers.",
    },
    {
      icon: <IoDocumentTextOutline />,
      title: "Comprehensive Product Information",
      description:
        " Each product listing includes detailed specifications, helping users make informed decisions for their projects.",
    },
    {
      icon: <IoMdSearch />,
      title: "User-Friendly Interface",
      description:
        "Designed for simplicity, the interface ensures that both novice and experienced users can navigate with ease and complete transactions effortlessly.",
    },
    {
      icon: <MdChecklistRtl />,
      title: "Secure Transactions",
      description:
        "Guarantees the security of all transactions, offering a range of trusted payment options and banking.",
    },
    {
      icon: <IoDocumentTextOutline />,
      title: "Comprehensive Product Information",
      description:
        "Each product listing includes detailed specifications, helping users make informed decisions.",
    },
  ];
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: "ease",
    swipe: true,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="key-features  ">
      <div className="">
        <img src={key} alt="key Stelmart" />
      </div>
      <div className="overlay custom-container-upper"></div>

      <div className="contents ">
        <h2 className=" key custom-inner-space font-merriweather">KEY FEATURES</h2>
        <p className=" feature custom-inner-space font-poppins">Solutions that ensure an unforgettable experience</p>

        <Slider {...settings} className="keys features-container custom-inner-space ">
          {features.map((feature, index) => (
            <div key={index} className="feature-box">
              <div className="icon">{feature.icon}</div>
              <h3 className="font-merriweather">{feature.title}</h3>
              <p className="font-poppins">{feature.description}</p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default KeyFeature;
